import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { StyledSubOptionsContainer } from '../PdfExportConfigDialog.styles';
import { CompanyPdfOptions } from '../PdfExportConfigDialog.types';
import { CompanySubOptionsProps } from './SubOptions.types';

export const CompanySubOptions = ({ options, onOptionsChange, showCondition }: CompanySubOptionsProps) => {
  if (!showCondition) {
    return null;
  }

  const handleOptionChange = (optionKey: keyof CompanyPdfOptions) => {
    onOptionsChange({
      ...options,
      [optionKey]: !options[optionKey],
    });
  };

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={options.valuationSummary}
              onChange={() => handleOptionChange('valuationSummary')}
            />
          }
          label="Valuation Summary"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.equityAllocation}
              onChange={() => handleOptionChange('equityAllocation')}
            />
          }
          label="Equity Allocation"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.concludedShareValues}
              onChange={() => handleOptionChange('concludedShareValues')}
            />
          }
          label="Concluded Share Values"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.financials}
              onChange={() => handleOptionChange('financials')}
            />
          }
          label="Financials"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.capTable}
              onChange={() => handleOptionChange('capTable')}
            />
          }
          label="Cap Table"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.fundOwnership}
              onChange={() => handleOptionChange('fundOwnership')}
            />
          }
          label="Fund Ownership"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.breakpointAnalysis}
              onChange={() => handleOptionChange('breakpointAnalysis')}
            />
          }
          label="Breakpoints"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={options.backsolve}
              onChange={() => handleOptionChange('backsolve')}
            />
          }
          label="Backsolve"
        />
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
